import React, { useEffect, useRef } from 'react';
import QRCode from 'qrcode';
const QRCodeDisplay = ({ link }) => {
  const qrCodeRef = useRef(null);
  useEffect(() => {
    if (link) {
      QRCode.toCanvas(qrCodeRef.current, link);
    }
  }, [link]);
  return (
    <div>
      <canvas ref={qrCodeRef}></canvas>
    </div>
  );
};
export default QRCodeDisplay;